export default "__VITE_ASSET__e7oPzSa2__"